import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useStore } from '@roc/client-portal-shared/hooks';
import FundingTemplateStore from 'libs/feature-documents/src/documents/stores/documentForms/fundingTemplateStore';

const useStyles = makeStyles({
  notAvailableText: {
    fontWeight: 'bold',
    textAlign: 'center',
  },
});

export type FundingTemplateNotAvailableProps = {
  store: FundingTemplateStore;
};

export const FundingTemplateNotAvailable = (props: FundingTemplateNotAvailableProps) => {
  const classes = useStyles();
  const { globalStore } = useStore();
  const { fundingTemplateErros } = props.store
  return (
    <Grid container alignItems="center" justifyContent="center">
      <Grid item xs={6}>
        {globalStore.isInternalPortal ?
          <ul>
            {fundingTemplateErros.errors.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
          :
          <Typography className={classes.notAvailableText}>
            Funding Template is not available right now, it will be available
            soon.
          </Typography>
        }
      </Grid>
    </Grid>
  );
};

export default FundingTemplateNotAvailable;
